export default "__VITE_ASSET__6c98fa2f__"